import styled from 'styled-components';
import { TypeStyle } from '../TypeStyle';
export const Button = styled.button `
  display: flex;
  gap: ${o => o.theme.spacing(1.5)};
  align-items: center;
  background-color: ${o => o.active && o.theme.color.deprecated.stoneLighter};
  border-radius: 3px;
  position: relative;
  padding: 5px 10px;
  white-space: nowrap;
  &:hover {
    background-color: ${o => o.theme.color.deprecated.stoneLighter};
  }
  &:disabled,
  &[aria-disabled='true'] {
    color: ${o => o.theme.color.text.tertiary.on.background};
    cursor: not-allowed;
  }
`;
export const Text = styled(TypeStyle.HeadlineMicro).attrs({
    isUppercase: true,
    textTransform: 'uppercase',
}) `
  display: inline-block;
  font-weight: 700;
`;
export const Icon = styled(Text) `
  padding-top: 2px;
  padding-left: 2px;
`;
//# sourceMappingURL=styles.js.map